import { z } from "zod";

export const ownerDocumentSchema = z.object({
  id: z.string(),
  owner_id: z.string(),
  doc_type: z.string(),
  doc_sub_type: z.string(),
});
